import { Box, Typography, useTheme } from "@mui/material";
import { Link, useLocation, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export interface AdminRoute {
    to: string;
    name: string;
}

interface Props {
    routes: AdminRoute[];
}

export default function AdminRouteSelector({ routes }: Props) {
    const theme = useTheme();

    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        if (routes.length != 1) {
            return;
        }

        const route = routes[0];

        if (pathname == route.to) {
            return;
        }

        void navigate({ to: route.to });
    }, [routes]);

    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            p={2}
            border={"1px solid grey"}
            width={"fit-content"}
            height={"fit-content"}
            gap={0.5}
            minWidth={275}
        >
            {routes.map((route, i) => (
                <Typography key={i}>
                    <Link
                        to={route.to}
                        activeProps={{
                            style: {
                                background: theme.palette.primary.main,
                                color: theme.palette.getContrastText(theme.palette.primary.main),
                                textDecoration: "none",
                                borderRadius: 5,
                            },
                        }}
                        style={{ padding: 5, textDecoration: "none", textWrap: "nowrap" }}
                    >
                        {route.name}
                    </Link>
                </Typography>
            ))}
        </Box>
    );
}
